import React, { useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import { ACCESS_DENIED_MESSAGE } from "../utils/accessDenied";

export { ACCESS_DENIED_MESSAGE };

const RedirectHandler = ({ message = ACCESS_DENIED_MESSAGE }) => {
  useEffect(() => {
    const toastId = toast.error(
      <div className="redirect-message">
        <div className="redirect-message__content">
          <span>{message}</span>
        </div>
      </div>,
      {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      }
    );

    return () => {
      toast.dismiss(toastId);
    };
  }, [message]);

  return (
    <>
      <span className="errmsg">{message}</span>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
};

export default RedirectHandler;
